<template>
  <agent-default>
    <div class="dashboard-body">
      <div class="tw-flex tw-justify-between tw-items-center tw-mb-6">
        <h2 class="c-navy-text tw-text-xl tw-font-bold">
          <i class="ph ph-chart-line-up tw-mr-2"></i> Analytics & Reports
        </h2>
        <div class="tw-flex tw-gap-3">
          <v-btn outlined color="gray" class="tw-bg-white">
            <i class="ph ph-calendar tw-mr-2"></i> This Year: 2026
          </v-btn>
          <v-btn color="primary">
            <i class="ph ph-download-simple tw-mr-2"></i> Export Report
          </v-btn>
        </div>
      </div>

      <!-- Snapshot Row -->
      <div class="snapshot-grid tw-mb-8">
        <div class="stat-card">
          <div class="stat-icon green">
            <i class="ph ph-trend-up"></i>
          </div>
          <div class="stat-details">
            <p>Gross Written Premium YTD</p>
            <div class="tw-flex tw-justify-between tw-items-end tw-w-full">
              <h3>Ksh 2.45M</h3>
              <span class="tw-text-xs tw-text-green-600 tw-font-bold tw-mb-1">+12.4%</span>
            </div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="ph ph-policy"></i>
          </div>
          <div class="stat-details">
            <p>Total Policies Sold</p>
            <div class="tw-flex tw-justify-between tw-items-end tw-w-full">
              <h3>184</h3>
              <span class="tw-text-xs tw-text-green-600 tw-font-bold tw-mb-1">+5%</span>
            </div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon yellow">
            <i class="ph ph-arrows-counter-clockwise"></i>
          </div>
          <div class="stat-details">
            <p>Renewal Retention Rate</p>
            <div class="tw-flex tw-justify-between tw-items-end tw-w-full">
              <h3>88%</h3>
              <span class="tw-text-xs tw-text-gray-500 tw-font-bold tw-mb-1">Stable</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Charts Area -->
      <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-6">

        <!-- Sales Performance Bar Chart -->
        <div class="chart-panel lg:tw-col-span-2">
          <div class="panel-header tw-mb-4">
            <h4 class="tw-text-md tw-font-bold c-navy-text">Monthly Sales Performance</h4>
            <span class="tw-text-xs c-gray-text">vs Target</span>
          </div>

          <div class="bar-chart-container">
            <div class="bar-chart">
              <div v-for="m in monthlySales" :key="m.month" class="bar-group">
                <div
                  class="bar"
                  :class="{ 'secondary': m.isCurrent }"
                  :style="{ height: m.value + '%' }"
                  :title="m.label"
                ></div>
                <span class="bar-label" :class="{ 'tw-font-bold': m.isCurrent }">{{ m.month }}</span>
              </div>
            </div>
          </div>

          <div class="tw-flex tw-justify-center tw-gap-6 tw-mt-8">
            <div class="tw-flex tw-items-center tw-gap-2 tw-text-xs c-gray-text">
              <span class="legend-dot" style="background: #00AEEF;"></span> Actual Sales
            </div>
            <div class="tw-flex tw-items-center tw-gap-2 tw-text-xs c-gray-text">
              <span class="legend-dot" style="background: #1E4276;"></span> Current Month
            </div>
          </div>
        </div>

        <!-- Product Breakdown List -->
        <div class="chart-panel">
          <div class="panel-header tw-mb-6">
            <h4 class="tw-text-md tw-font-bold c-navy-text">Product Distribution</h4>
          </div>

          <div class="tw-flex tw-flex-col tw-gap-6">
            <div v-for="p in productDistribution" :key="p.name">
              <div class="tw-flex tw-justify-between tw-text-sm tw-mb-2">
                <span class="tw-font-medium">{{ p.name }}</span>
                <span class="tw-font-bold c-navy-text">{{ p.percentage }}%</span>
              </div>
              <v-progress-linear
                :value="p.percentage"
                :color="p.color"
                height="8"
                rounded
              ></v-progress-linear>
            </div>
          </div>
        </div>

      </div>
    </div>
  </agent-default>
</template>

<script>
import AgentDefault from '@/components/layout/AgentDefault';

export default {
  name: 'AgentReports',
  components: {
    AgentDefault,
  },
  data() {
    return {
      monthlySales: [
        { month: 'Jan', value: 40, label: 'Ksh 120k' },
        { month: 'Feb', value: 65, label: 'Ksh 195k' },
        {
          month: 'Mar', value: 85, label: 'Ksh 255k', isCurrent: true,
        },
        { month: 'Apr', value: 10, label: 'Pending' },
        { month: 'May', value: 10, label: 'Pending' },
        { month: 'Jun', value: 10, label: 'Pending' },
      ],
      productDistribution: [
        { name: 'Motor Comprehensive', percentage: 45, color: '#00AEEF' },
        { name: 'Domestic Package', percentage: 30, color: '#1E4276' },
        { name: 'WIBA', percentage: 15, color: '#FFC107' },
        { name: 'Others', percentage: 10, color: '#94a3b8' },
      ],
    };
  },
  metaInfo: {
    title: 'Reports & Analytics',
  },
};
</script>

<style scoped>
.chart-panel {
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.bar-chart-container {
  height: 250px;
  margin-top: 20px;
  position: relative;
}

.bar-chart {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  height: 100%;
  padding-bottom: 30px;
  border-bottom: 1px dashed #E2E8F0;
}

.bar-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  position: relative;
}

.bar {
  width: 100%;
  max-width: 44px;
  background: #00AEEF;
  border-radius: 4px 4px 0 0;
  transition: height 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}

.bar:hover {
  filter: brightness(1.05);
}

.bar.secondary {
  background: #1E4276;
}

.bar-label {
  position: absolute;
  bottom: -28px;
  font-size: 0.75rem;
  color: #64748B;
}

.legend-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.panel-header {
  border-bottom: 1px solid #F1F5F9;
  padding-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
